<div class="active-alarms">
    <div class="alarm-container">
        <div class="alarm" *ngFor="let alarm of alarmsTypes">
            <div class="alarm-type">{{alarm.type}}</div>
            <div class="alarm-count-container">
                <div class="alarm-count" *ngIf="alarm.count > 0"
                     [style]="'width: ' + (alarm.count/totalAlarms) * 100  + '%'" [class]="alarm.type">{{alarm.count}}</div>
                <div *ngIf="alarm.count <= 0">-</div>
            </div>
        </div>
    </div>

    <div class="total-alarms">
        <div>TOTAL ALARMS</div>
        <div>{{totalAlarms}}</div>
    </div>
  <div class="note-only-unacknowledged-alarms">*Only unacknowledged alarms are displayed.</div>
</div>
